import { render, staticRenderFns } from "./Signin.vue?vue&type=template&id=665878a6"
import script from "./Signin.vue?vue&type=script&lang=ts"
export * from "./Signin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports